module.exports = __webpack_public_path__ + "public/Icons/completed_bookings.svg?e546a8f5";